import NextImage from "next/image";
import { Stack, Text, Heading } from "@chakra-ui/react";

import LogoIdealniNajemce from "components/Chakra/Icons/LogoIdealninajemce";
import PhoneNumberSwitch from "components/PhoneNumberSwitch";

interface IProps {
  photoUrl?: string;
  name: string;
  phone?: string;
  textTypeUser: string;
  isInOffer?: boolean;
  offerId?: number;
  hasPhone?: boolean;
  onPhoneClick?: () => void;
}

const ContactAvatar: React.FunctionComponent<IProps> = ({
  photoUrl,
  textTypeUser,
  name,
  phone,
  isInOffer,
  hasPhone,
  onPhoneClick,
}) => (
  <Stack
    direction="column"
    backgroundColor={isInOffer ? "ud-grey-150" : "ud-grey-200"}
    py="16px"
    px="16px"
    borderRadius="6px"
    borderColor="ud-grey-300"
    borderWidth={isInOffer ? undefined : "1px"}
    w="100%"
    spacing={4}
  >
    <Stack
      direction="row"
      borderBottomWidth={phone ? "1px" : undefined}
      spacing={3}
    >
      {photoUrl && (
        <NextImage
          src={photoUrl}
          alt="avatar"
          width="50"
          height="50"
          style={{ borderRadius: "50%", width: "fit-content" }}
        />
      )}
      <Stack spacing={0} flex={1}>
        {isInOffer ? (
          <Stack align="flex-start">
            <Text align="left" variant="small_2">
              Bezstarostné bydlení se službou
            </Text>
            <LogoIdealniNajemce h="30px" w="auto" fill="ud-primary" />
          </Stack>
        ) : (
          <Stack align="flex-start">
            <Heading as="h2" variant="h3">
              {name}
            </Heading>
            <Text>{textTypeUser}</Text>
          </Stack>
        )}
      </Stack>
    </Stack>
    {hasPhone && phone?.length && (
      <Stack direction="row" justifyContent="space-between">
        <PhoneNumberSwitch phoneNumber={phone} onPhoneClick={onPhoneClick} />
      </Stack>
    )}
  </Stack>
);

export default ContactAvatar;
